import { numberToKiloFormat } from "../../utils/utils";

const CustomTooltip = ({ active, payload, label, coordinate, activeLineId }) => {
    // console.log("=============")
    // console.log("active ", active)
    // console.log("label ", label)
    // console.log("coordinate ", coordinate)
    // console.log("payload ", payload)
    // console.log("activeLineId ", activeLineId)
    if (active && payload && payload.length) {
        // console.log("-- In")
        const activeItem = payload.find((item) => item.dataKey === activeLineId);
        // console.log("-- In")
        if (!activeItem) return null;
    
        // Format the date to DD.MM.YYYY
        const date = new Date(label);
        const formattedDate = `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()}`;
        
        // Format value (e.g., 132500 -> 132.5K)
        var formattedValue = numberToKiloFormat(activeItem.value, { precision: 2 });
        
        // const formattedValue = `${(activeItem.value / 1000).toFixed(1)}K`;
    
        // Extract coordinates from Recharts
        const { x, y } = coordinate;
    
        return (
          <div
            style={{
              position: 'absolute',
              left: x,
              top: y - 20, // Offset to sit above the dot
              transform: 'translate(-50%, -100%)', // Center horizontally and move above y
              backgroundColor: '#000',
              color: '#fff',
              padding: '8px 12px',
              borderRadius: '16px',
              textAlign: 'center',
              fontSize: '14px',
              whiteSpace: 'nowrap',
              pointerEvents: 'none',
            }}
          >
            <div style={{ fontWeight: 500, marginBottom: '2px', fontSize: "18px" }}>{formattedValue}</div>
            <div style={{ fontSize: '12px', fontWeight: 400, opacity: 0.7 }}>{formattedDate}</div>
            
            {/* The Triangle (Caret) */}
            <div
              style={{
                position: 'absolute',
                bottom: '-6px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: 0,
                height: 0,
                borderLeft: '6px solid transparent',
                borderRight: '6px solid transparent',
                borderTop: '6px solid #000',
              }}
            />
          </div>
        );
      }
    return null;
};

export default CustomTooltip;
